import geo from '@/geo'

// Adds the distance line and directions link for any component exposing a
// `location` computed. Display priority: admin label ("Event", "Mail-in"),
// then "Multiple locations" for multi-place embeds, then distance from the
// visitor ("2.5 miles", upgraded to "2.5 miles; 7 minutes" once drive time
// arrives), otherwise nothing.
export default {

	data: function() {

		return {
			drive: false
		}

	},

	computed: {

		position: function() {

			return this.$store.getters['position']

		},

		distanceLine: function() {

			var location = this.location

			if (!location || !location.id) return ''

			if (location.label) return location.label

			if (location.multiple) return 'Multiple locations'

			if (location.lat === null || location.lat === undefined) return ''

			if (!this.position) return ''

			// straight-line distance shows for everyone; drive time only gets
			// appended for US visitors (Google has no route across an ocean —
			// see the isInUS guard in fetchDriveTime)
			if (this.drive) return geo.formatMiles(this.drive.miles) + '; ' + geo.formatMinutes(this.drive.minutes)

			return geo.formatMiles(geo.haversineMiles(this.position, location))

		},

		directionsUrl: function() {

			var location = this.location

			if (!location || !location.id) return false

			if (!location.map && (location.lat === null || location.lat === undefined)) return false

			return geo.directionsUrl(location)

		}

	},

	watch: {

		location: {

			immediate: true,

			handler: function(n, o) {

				if (n && o && n.id === o.id) return

				this.drive = false

				this.locateForDistance()

			}

		},

		position: function() {

			this.fetchDriveTime()

		}

	},

	methods: {

		locateForDistance: function() {

			var location = this.location

			if (!location || !location.id || location.lat === null || location.lat === undefined) return

			this.$store.dispatch('locate')

			this.fetchDriveTime()

		},

		fetchDriveTime: function() {

			var location = this.location

			if (!location || !location.id || location.lat === null || location.lat === undefined) return

			if (!this.position || this.drive) return

			// don't call Google for visitors outside the US
			if (!geo.isInUS(this.position)) return

			var id = location.id

			geo.driveTime(this.$store.getters['key'], this.position, id).then(function(result) {

				if (!result) return

				// share it so the closest-first sort can order by the same road
				// miles the line displays (see mixin/blocksort)
				this.$store.commit('drive', { id: id, result: result })

				if (this.location && this.location.id === id) this.drive = result

			}.bind(this))

		}

	}

}
